// Stato di Google Identity Services condiviso fra le istanze del modulo: sulla stessa
// pagina ne convivono piu' d'una (trovacigusto, header della home) e master-homepage
// carica questo file due volte, ma lo script va inserito e inizializzato una volta sola.
window.tgGoogleSdk = window.tgGoogleSdk || { promise: null, module: null }

function GoogleModule () {
  var self = this

  self.user = ko.observable(null)
  self.loading = ko.observable(false)
  self.image = ko.observable(null)
  self.registerType = ko.observable('user')
  self.invitationCode = ko.observable('')

  self.redirectCallback = function (redirectUrl) {
    location.href = redirectUrl
  }

  function gsiAvailable () {
    // Con Google Maps caricato `google` esiste comunque: conta solo google.accounts.
    return typeof google !== 'undefined' && !!google.accounts && !!google.accounts.id
  }

  /**
   * Carica Google Identity Services su richiesta, una volta sola, e lo inizializza.
   *
   * Prima gsi/client era nell'head di ogni layout e initialize() partiva al load di
   * ogni pagina: un servizio di Google anche per chi non usa il login social. Ora lo
   * script arriva solo quando l'utente chiede di accedere (pre-caricamento: vedi
   * LoginRegisterModule.preloadSocialSdks) o usa un pulsante Google.
   * google.accounts si usa solo qui e nelle funzioni chiamate dopo il caricamento.
   */
  self.loadSdk = function () {
    var sdk = window.tgGoogleSdk
    if (sdk.promise) {
      return sdk.promise
    }

    sdk.promise = new Promise(function (resolve, reject) {
      var script = document.createElement('script')

      function fail () {
        sdk.promise = null
        if (script.parentNode) {
          script.parentNode.removeChild(script)
        }
        reject(new Error('Google Identity Services non caricato'))
      }

      function initialize () {
        try {
          // Un solo initialize per pagina (Google avverte se lo si ripete): la risposta
          // va al modulo che ha chiesto l'accesso per ultimo (vedi login()).
          google.accounts.id.initialize({
            client_id: '301120554578-5ctenkonmp7266gmkbqoarbd5scunl2c.apps.googleusercontent.com',
            callback: function (response) {
              if (sdk.module) {
                sdk.module.googleLoginCallback(response)
              }
            }
          })
        } catch (e) {
          fail()
          return
        }
        resolve()
      }

      if (gsiAvailable()) {
        initialize()
        return
      }

      script.async = true
      script.src = 'https://accounts.google.com/gsi/client'
      script.onerror = fail
      script.onload = function () {
        if (gsiAvailable()) {
          initialize()
        } else {
          fail()
        }
      }
      document.head.appendChild(script)
    })

    return sdk.promise
  }

  function closeSignInDialog () {
    var dialog = document.getElementById('tg-google-signin')
    if (dialog && dialog.parentNode) {
      dialog.parentNode.removeChild(dialog)
    }
    document.removeEventListener('keydown', closeSignInDialogOnEscape)
  }

  function closeSignInDialogOnEscape (event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      closeSignInDialog()
    }
  }

  // L'attesa della risposta di Google e' una sola per pagina, come lo script.
  function stopWaiting () {
    clearTimeout(window.tgGoogleSdk.waiting)
    window.tgGoogleSdk.waiting = null
  }

  /**
   * Riquadro con il pulsante ufficiale di Google, che apre la sua finestra di accesso.
   *
   * Serve a chi non ha una sessione Google aperta nel browser (tipico di Edge, Firefox,
   * Safari, finestre anonime): One Tap propone solo gli account gia' collegati e, se non ce
   * ne sono, non mostra nulla. La risposta arriva alla stessa callback di initialize().
   */
  function openSignInDialog () {
    stopWaiting()
    closeSignInDialog()

    var dialog = document.createElement('div')
    dialog.id = 'tg-google-signin'
    dialog.setAttribute('role', 'dialog')
    dialog.setAttribute('aria-modal', 'true')
    dialog.setAttribute('aria-label', 'Accedi con Google')
    dialog.style.cssText = 'position:fixed;top:0;right:0;bottom:0;left:0;z-index:100000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(0,0,0,.55)'
    dialog.innerHTML = '<div style="width:100%;max-width:360px;padding:24px;border-radius:12px;background:#fff;text-align:center;box-shadow:0 10px 40px rgba(0,0,0,.3)">' +
      '<p style="margin:0 0 16px;font-weight:600;color:#222">Accedi con il tuo account Google</p>' +
      '<div class="tg-google-signin-button" style="display:flex;justify-content:center;height:44px;overflow:hidden"></div>' +
      '<p style="margin:16px 0 0"><a href="#" class="tg-google-signin-close">Annulla</a></p>' +
      '</div>'
    dialog.addEventListener('click', function (event) {
      var close = event.target === dialog || (event.target.className || '').indexOf('tg-google-signin-close') !== -1
      if (close) {
        event.preventDefault()
        closeSignInDialog()
      }
    })
    document.body.appendChild(dialog)
    document.addEventListener('keydown', closeSignInDialogOnEscape)

    // Altezza fissa e resto nascosto: mentre il pulsante vero si carica Google ne mostra uno
    // provvisorio, e per qualche istante i due comparivano uno sotto l'altro.
    var holder = dialog.querySelector('.tg-google-signin-button')
    try {
      google.accounts.id.renderButton(holder, {
        type: 'standard',
        theme: 'outline',
        size: 'large',
        text: 'continue_with',
        shape: 'pill',
        locale: 'it',
        // Google accetta da 200 a 400 pixel: su un telefono stretto il riquadro e' piu' piccolo di 280.
        width: Math.max(200, Math.min(280, holder.clientWidth))
      })
    } catch (e) {
      closeSignInDialog()
      pNotify('Accesso con Google non disponibile. Riprova più tardi o accedi con email e password.', 'warning')
    }
  }

  /**
   * Accesso con Google: prima One Tap, che a chi ha gia' una sessione Google propone il
   * suo account senza altre finestre. Non e' un popup: non serve che parta dentro il click,
   * basta attendere lo script.
   *
   * Se Google fa sapere che One Tap non puo' comparire (momento "skipped": nessuna
   * sessione, riquadro chiuso di recente) si apre il riquadro con il pulsante ufficiale.
   * Lo stesso se entro 3 secondi non arriva ne' l'accesso ne' quella risposta: Google non
   * avvisa sempre (provato il 12/10/2026 senza sessione: una volta dopo 2 secondi, altre mai)
   * e dove One Tap non e' supportato non avvisa affatto. Chi sta ancora guardando One Tap si
   * ritrova anche il riquadro: portano allo stesso accesso. Si controlla solo
   * isSkippedMoment(): gli altri controlli sull'esito (isNotDisplayed e simili) Google li
   * ha dichiarati in dismissione.
   */
  self.login = function () {
    window.tgGoogleSdk.module = self
    self.loadSdk()
      .then(function () {
        stopWaiting()
        closeSignInDialog()

        // Ogni click e' un tentativo a se': la risposta di un One Tap precedente (anche quella
        // provocata dal cancel() qui sotto) non deve aprire il riquadro di questo.
        var attempt = window.tgGoogleSdk.attempt = (window.tgGoogleSdk.attempt || 0) + 1

        // Un One Tap rimasto in sospeso da un click precedente impedirebbe a questo di partire.
        try {
          google.accounts.id.cancel()
        } catch (e) {}

        window.tgGoogleSdk.waiting = setTimeout(openSignInDialog, 3000)
        google.accounts.id.prompt(function (notification) {
          var skipped = typeof notification.isSkippedMoment === 'function' && notification.isSkippedMoment()
          if (skipped && attempt === window.tgGoogleSdk.attempt && window.tgGoogleSdk.waiting) {
            openSignInDialog()
          }
        })
      })
      .catch(function () {
        pNotify('Accesso con Google non disponibile: non è stato possibile caricare lo script di Google. Controlla eventuali blocchi del browser.', 'warning')
      })
  }

  /**
   * Revoca anche su Google il consenso dato al sito. L'utente ha appena chiesto di
   * scollegare Google, quindi lo script si carica qui se non c'e' ancora; se non arriva,
   * lo scollegamento sul sito e' comunque avvenuto.
   */
  self.revoke = function (hint) {
    self.loadSdk()
      .then(function () {
        google.accounts.id.revoke(hint, function () {
          console.log('consent revoked')
        })
      })
      .catch(function () {})
  }

  self.logout = function () {
    self.loading(true)
    rest('GET', '/api/v2/google/unbind')
      .then(function (response) {
        if (response.status === 'user.reset.password') {
          self.user(null)
          pNotify('Il tuo account Google è stato scollegato con successo. Se non lo hai ancora fatto  <a href="/user/settings">imposta una password</a> per poter accedere', 'warning')
        }
        self.revoke(response.data)
        self.loading(false)
      })
      .catch(function () {
        self.loading(false)
        pNotify('Si è verificato un errore. Prova a ricaricare la pagina e/o riprova più tardi', 'error')
      })
  }

  self.bindUser = function (payload, onSuccess) {
    self.loading(true)
    return rest('POST', '/api/v2/google/register', payload)
      .then(function (response) {
        if (response.success) {
          pNotify('Il tuo account Google è stato collegato con successo')
          self.user(response.data.user)
          trovacigusto.loginRegisterModule.onesignalGetData()
          onSuccess(response)
        } else {
          pNotify('Il tuo account Google non è stato collegato.', 'warning')
        }
        self.loading(false)
      })
      .catch(function () {
        self.loading(false)
        pNotify('Si è verificato un errore. Prova a ricaricare la pagina e/o riprova più tardi', 'error')
      })
  }

  self.googleLoginCallback = function (response) {
    console.log('Google Login Callback')

    // Google ha risposto: non serve piu' ne' attendere ne' il riquadro con il suo pulsante.
    stopWaiting()
    closeSignInDialog()

    let idToken
    if (response.credential) {
      // browser-only
      idToken = response.credential
    } else {
      // native-only
      idToken = response.idToken
    }

    if (idToken) {
      const payloadObj = tgJwtPayload(idToken)
      if (payloadObj) {
        const { given_name, family_name, email, sub } = payloadObj

        const payload = {
          email,
          first_name: given_name,
          last_name: family_name,
          provider_type: 'google',
          provider_token: idToken,
          provider_uid: sub,
          type: self.registerType(),
          invitationCode: self.invitationCode(),
          redirect: window.location.href
        }
        //debugLog(payload)

        self.bindUser(payload, function (response) {
          self.redirectCallback(response.data.redirect ? response.data.redirect : '/');
        })
      }
    } else {
      pNotify('Si è verificato un errore. Non hai autorizzato correttamente il tuo account Google', 'warning')
    }
  }

  return self
}
